import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import NavbarModulo from '../../components/NavbarModulo';

import {
    renderField,
    AsyncSelectField,
} from "../../Utils/renderField/renderField";

function LineaPromocionalForm(props) {
    const { handleSubmit, crear, modulo, listarCuentasContables } = props;
    
    const editar = window.location.href.includes('editar');
    let titulo = editar ? 'Modificar linea promocional' : 'Crear linea promocional';
    let disabled = false;
    if (crear === false && editar === false) {
        disabled = true;
        titulo = 'Ver linea promocional'
    }
    let autoFocus = true;
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    return (
        <div>
            <NavbarModulo
                modulo={modulo}
                titulo={titulo}
            />
            <form onSubmit={handleSubmit}>
                <br />
                <div className="mb-4 card card-small text-white bg-dark mb-3">
                    <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                        <div className="d-flex flex-column flex-1 mx-4">
                            {crear === true &&
                                <div className='mb-2 row'>
                                    <div className='col-6'>
                                        <Field
                                            name="descripcion"
                                            autoFocus={autoFocus}
                                            placeholder="Linea promocional"
                                            className="form-control"
                                            component={renderField}
                                            disabled={disabled}
                                            msj="Linea promocional"
                                        />
                                    </div>
                                    <div className='col-6'>
                                        <Field
                                            name="cuenta"
                                            placeholder="Cuenta contable..."
                                            className="form-control-find"
                                            component={AsyncSelectField}
                                            loadOptions={listarCuentasContables}
                                            msj="Cuenta contable"
                                        />
                                    </div> 
                                </div>
                            }
                            {crear === false && editar === false &&
                                <div>
                                    <div className='mb-2 row'>
                                        <div className='col-2'>
                                            <Field
                                                name="codigo"
                                                autoFocus={autoFocus}
                                                placeholder="Linea promocional"
                                                className="form-control"
                                                component={renderField}
                                                disabled={disabled}
                                                msj="Codigo"
                                            />
                                        </div>
                                    </div>
                                    <div className='mb-2 row'>
                                        <div className='col-6'>
                                            <Field
                                                name="descripcion"
                                                autoFocus={autoFocus}
                                                placeholder="Linea promocional"
                                                className="form-control"
                                                component={renderField}
                                                disabled={disabled}
                                                msj="Linea promocional"
                                            />
                                        </div>
                                        <div className='col-6'>
                                            <Field
                                                name="nombre_cuenta"
                                                placeholder="Linea promocional"
                                                className="form-control"
                                                component={renderField}
                                                disabled={disabled}
                                                msj="Cuenta contable"
                                            />
                                        </div> 
                                    </div>
                                </div>
                            }
                            {crear === false && editar === true &&
                                <div>
                                    <div className='mb-2 row'>
                                        <div className='col-2'>
                                            <Field
                                                name="codigo"
                                                autoFocus={autoFocus}
                                                placeholder="Linea promocional"
                                                className="form-control"
                                                component={renderField}
                                                disabled={true}
                                                msj="Codigo"
                                            />
                                        </div>
                                    </div>
                                    <div className='mb-2 row'>
                                        <div className='col-6'>
                                            <Field
                                                name="descripcion"
                                                autoFocus={autoFocus}
                                                placeholder="Linea promocional"
                                                className="form-control"
                                                component={renderField}
                                                msj="Linea promocional"
                                            />
                                        </div>
                                        <div className='col-6'>
                                            <Field
                                                name="nombre_cuenta"
                                                placeholder="Linea promocional"
                                                className="form-control"
                                                component={renderField}
                                                disabled={true}
                                                msj="Cuenta contable"
                                            />
                                        </div> 
                                    </div>
                                    <div className='mb-2 row'>
                                        <div className='col-6'>
                                        </div>
                                        <div className='col-6'>
                                            <Field
                                                name="cuenta_mod"
                                                placeholder="Cuenta contable..."
                                                className="form-control-find"
                                                component={AsyncSelectField}
                                                loadOptions={listarCuentasContables}
                                                msj="Cuenta contable"
                                            />
                                        </div> 
                                    </div>
                                </div>
                            }
                            <div className='d-flex flex-row mt-3'>
                                {disabled == false &&
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        type='submit'
                                    >
                                        {editar ? 'Modificar' : 'Guardar'}
                                    </button>
                                }
                                <a
                                    href={`/#/visitador_medico/${id_emp[5]}/linea_promocional`}
                                    className='btn btn-secondary mb-3'
                                >
                                    Regresar
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

LineaPromocionalForm.propTypes = {
    handleSubmit: PropTypes.func,
    crear: PropTypes.bool,
    lectura: PropTypes.object,
    modulo: PropTypes.object,
};

export default reduxForm({
    form: 'FormLineaPromocionalVM',
})(LineaPromocionalForm);
